import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import EMTLevel from "../../components/emtLevel";
import Note from "../../components/note";
import MyLink from "../../components/myLink";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Note id="note-1" mdxType="Note">
  <strong>
    Only for arrests of Cardiac etiology.
    <br />
    For primary respiratory etiology, ventilate immediately as part of CPR.
  </strong>
    </Note>
    <Note id="note-2" alignment="left" mdxType="Note">
  <ul>
    <li>Perform 2 minutes cycles of uninterrupted chest compressions</li>
    <li>Interrupt chest compressions only after each 2 minute cycle</li>
    <li>Follow current AHA/ILCOR recommendations for cardiac arrest management.</li>
  </ul>
    </Note>
    <br />
    <EMTLevel level="basic" mdxType="EMTLevel">
  <ul style={{
        paddingTop: "0.5rem"
      }}>
    <li>
      <MyLink to="/sections/1/1.0-routine-patient-care" mdxType="MyLink">1.0 - Routine Patient Care</MyLink>
      - with focus on high quality CPR
    </li>
    <li>Immediate chest compressions at a rate of 100-120 per minute</li>
    <li>Use AED as soon as possible with minimal interruption of chest compressions</li>
    <li>Continue 2 minute cycles of uninterrupted chest compressions followed by
      AED analysis and shock for 4 cycles (first 8 MINUTES) </li>
      <ul>
        <li>Place an oral or nasal airway</li>
      </ul>
    <li>Ventilation / oxygenation options during 4 cycles (8 minutes):</li>
      <ul>
        <li>BVM ventilation during recoil and without interrupting compressions OR </li>
        <li>If part of a care bundle, apply high flow oxygen via NRB</li>
      </ul>
    <li>Ventilation / oxygenation options after 4 cycles (after 8 MINUTES):
      <ul>
        <li>Continue 2 minute cycles of uninterrupted chest compressions.</li>
        <li>If passive insufflation was used, switch to BVM ventilation.</li>
      </ul>
    </li>
  </ul>
    </EMTLevel>
    <EMTLevel level="advanced" mdxType="EMTLevel">
  <ul>
    <li>Consider placement of a supraglottic airway device.</li>
    <li>Place IV/IO without interrupting chest compressions.</li>
  </ul>
    </EMTLevel>
    <EMTLevel level="paramedic" mdxType="EMTLevel">
  <ul>
    <li>
      If utilizing a BVM, monitor quantitative waveform capnography throughout
      resuscitation to assess CPR quality and to monitor for signs of return of
      spontaneous circulation (ROSC)
    </li>
    <li>
      Provide manual defibrillation as indicated after each 2 minute cycle
    </li>
    <li>After 4 cycles (8 minutes):</li>
    <ul>
      <li>
        Consider endotracheal intubation or use an alternative airway without
        interrupting chest compressions
      </li>
      <li>
        If authorized and trained by AHMD, Paramedics may use mechanical
        ventilators in rate control mode with the following settings:
      </li>
      <ul>
        <li>Rate of 8-12 breaths per minute</li>
        <li>Tidal volume 300-500mL</li>
        <li>
          Start at FiO2 1.0 (100%) then titrate to maintain SpO2 &gt; 94% (90% for
          COPD patients)
        </li>
        <li>Relief pressure 45-60 cmH2O</li>
        <li>
          Paramedics may utilize mechanical ventilator following the initiation
          of respiratory component at least 8 minutes after start of
          resuscitation even if ROSC has occurred.
        </li>
      </ul>
    </ul>
  </ul>
    </EMTLevel>
    <Note id="note-3" alignment="left" mdxType="Note">
  PEARLS:
  <ul>
    <li>
      It is expected, unless special circumstances are present, initial 8
      minutes of resuscitation will be performed on scene.
    </li>
    <li>
      Early CPR and defibrillation are the most effective therapies for cardiac
      arrest care.
    </li>
    <li>
      Minimize interruptions in chest compression, as pauses rapidly return the
      blood pressure to zero and stop perfusion to the heart and brain.
    </li>
    <li>
      <strong>
        Recognizing the goal of immediate uninterrupted chest compressions,
        consider delaying application of mechanical CPR devices until after the
        first four cycles (8 minutes). If applied during the first 4 cycles, the
        goal is to limit interruptions. Mechanical devices should only be used by
        services that are practiced and skilled at their application.
      </strong>
    </li>
    <li>Switch compressors at least every two minutes to minimize fatigue.</li>
    <li>
      Perform chest compressions while defibrillator is charging and resume
      compressions immediately after the shock is delivered.
    </li>
  </ul>
    </Note>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      